// extracted by mini-css-extract-plugin
export default {"tableRow":"violationList_tableRow__T8eOj","tableCell":"violationList_tableCell__8eCP9"};